import { LOGO_URL } from "./constants";

export const NavBar = ({ onLogin, onArchivedClick }) => (
  <header className="nav" data-testid="landing-nav">
    <div className="nav-brand">
      <img
        src={LOGO_URL}
        alt="KIRA Markets — AI-Powered Stock Research & Market Intelligence"
        className="nav-logo"
        data-testid="nav-logo"
      />
      <div className="nav-brand-text">
        <div className="nav-brand-title">
          <span className="brand-silver">KIRA</span>
          <span className="brand-gold">MARKETS</span>
        </div>
        <div className="nav-brand-sub">AI-Powered Stock Research &amp; Market Intelligence</div>
      </div>
    </div>
    <nav className="nav-links">
      <a href="#features" data-testid="nav-features">Features</a>
      <a href="#archived-research" data-testid="nav-archived" onClick={onArchivedClick}>Research</a>
      <a href="#team" data-testid="nav-team">Team</a>
      <a href="#pricing" data-testid="nav-access">Access</a>
    </nav>
    <button
      className="btn btn-gold"
      onClick={onLogin}
      data-testid="nav-login-btn"
    >
      Sign In
    </button>
  </header>
);
